import useTypedContext from "hooks/useTypedContext";
import {
  AccessResult,
  NO_ACCESS_MESSAGE,
  hasAdminAccess,
  hasAllRequiredActionsInAnySpace,
} from "utils/access";
import { Action } from "types/generated";
import { AccountContext } from "views/AccountWrapper";

const CLOUD_INTEGRATION_CREATE_ACCESS_TYPES = [Action.SpaceAdmin];

/**
 * Hook that returns whether the current user can create a cloud integration (e.g. AWS).
 * Without a spaceId, checks for SpaceAdmin in at least one space. With a spaceId, scopes the
 * check to that specific space instead — matching the backend, which requires SpaceAdmin on the
 * target space and has no dedicated cloud-integration-create action.
 * @returns {AccessResult} Object indicating if user can create a cloud integration and a message if not
 */
const useCanCreateCloudIntegration = (spaceId?: string): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = spaceId
    ? hasAdminAccess(viewer, spaceId)
    : hasAllRequiredActionsInAnySpace(CLOUD_INTEGRATION_CREATE_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateCloudIntegration;
